const MODIFIERS_LOAD = 'MODIFIERS_LOAD';
const MODIFIERS_LOAD_SUCCESS = 'MODIFIERS_LOAD_SUCCESS';
const MODIFIERS_LOAD_FAIL = 'MODIFIERS_LOAD_FAIL';

const MODIFIER_LOAD = 'MODIFIER_LOAD';
const MODIFIER_LOAD_SUCCESS = 'MODIFIER_LOAD_SUCCESS';
const MODIFIER_LOAD_FAIL = 'MODIFIER_LOAD_FAIL';

const MODIFIER_NEW_LOAD = 'MODIFIER_NEW_LOAD';
const MODIFIER_NEW_LOAD_SUCCESS = 'MODIFIER_NEW_LOAD_SUCCESS';
const MODIFIER_NEW_LOAD_FAIL = 'MODIFIER_NEW_LOAD_FAIL';

const MODIFIER_NEW = 'MODIFIER_NEW';
const MODIFIER_NEW_SUCCESS = 'MODIFIER_NEW_SUCCESS';
const MODIFIER_NEW_FAIL = 'MODIFIER_NEW_FAIL';

const MODIFIER_REMOVE = 'MODIFIER_REMOVE';
const MODIFIER_REMOVE_SUCCESS = 'MODIFIER_REMOVE_SUCCESS';
const MODIFIER_REMOVE_FAIL = 'MODIFIER_REMOVE_FAIL';

const MODIFIERS_CHANGE_STATUS = 'MODIFIERS_CHANGE_STATUS';
const MODIFIERS_CHANGE_ITEM_POSITION = 'MODIFIERS_CHANGE_ITEM_POSITION';
const MODIFIERS_CHANGE_ITEM_POSITION_SUCCESS = 'MODIFIERS_CHANGE_ITEM_POSITION_SUCCESS';
const MODIFIERS_CHANGE_ITEM_POSITION_FAIL = 'MODIFIERS_CHANGE_ITEM_POSITION_FAIL';

const MODIFIERS_CHANGE_POSITION = 'MODIFIERS_CHANGE_POSITION';
const MODIFIERS_CHANGE_POSITION_SUCCESS = 'MODIFIERS_CHANGE_POSITION_SUCCESS';
const MODIFIERS_CHANGE_POSITION_FAIL = 'MODIFIERS_CHANGE_POSITION_FAIL';

const MODIFIERS_NEW = 'MODIFIERS_NEW';
const MODIFIERS_NEW_SUCCESS = 'MODIFIERS_NEW_SUCCESS';
const MODIFIERS_NEW_FAIL = 'MODIFIERS_NEW_FAIL';

const MODIFIERS_EDIT = 'MODIFIERS_EDIT';
const MODIFIERS_EDIT_SUCCESS = 'MODIFIERS_EDIT_SUCCESS';
const MODIFIERS_EDIT_FAIL = 'MODIFIERS_EDIT_FAIL';

const MODIFIER_CATEGORY_NAME_EDIT = 'MODIFIER_CATEGORY_NAME_EDIT';
const MODIFIER_CATEGORY_NAME_EDIT_SUCCESS = 'MODIFIER_CATEGORY_NAME_EDIT_SUCCESS';
const MODIFIER_CATEGORY_NAME_EDIT_FAIL = 'MODIFIER_CATEGORY_NAME_EDIT_FAIL';

const MODIFIER_EDIT = 'MODIFIER_EDIT';
const MODIFIER_EDIT_SUCCESS = 'MODIFIER_EDIT_SUCCESS';
const MODIFIER_EDIT_FAIL = 'MODIFIER_EDIT_FAIL';

const MODIFIERS_MODAL_NEW = 'MODIFIERS_MODAL_NEW';
const MODIFIERS_MODAL_EDIT = 'MODIFIERS_MODAL_EDIT';

const MODIFIER_CATEGORIES_NEW = 'MODIFIER_CATEGORIES_NEW';
const MODIFIER_CATEGORIES_NEW_SUCCESS = 'MODIFIER_CATEGORIES_NEW_SUCCESS';
const MODIFIER_CATEGORIES_NEW_FAIL = 'MODIFIER_CATEGORIES_NEW_FAIL';

const MODIFIER_ARCHIVE = 'MODIFIER_ARCHIVE';
const MODIFIER_ARCHIVE_SUCCESS = 'MODIFIER_ARCHIVE_SUCCESS';
const MODIFIER_ARCHIVE_FAIL = 'MODIFIER_ARCHIVE_FAIL';

const MODIFIER_UNARCHIVE = 'MODIFIER_UNARCHIVE';
const MODIFIER_UNARCHIVE_SUCCESS = 'MODIFIER_UNARCHIVE_SUCCESS';
const MODIFIER_UNARCHIVE_FAIL = 'MODIFIER_UNARCHIVE_FAIL';

export const onModifiersLoad = () => ({type: MODIFIERS_LOAD })
export const onModifiersLoadSuccess = (data) => ({type: MODIFIERS_LOAD_SUCCESS, data })
export const onModifiersLoadFail = (e) => ({type: MODIFIERS_LOAD_FAIL, e })

export const onModifierLoad = (itemId) => ({type: MODIFIER_LOAD,itemId});
export const onModifierLoadSuccess = (data) => ({ type: MODIFIER_LOAD_SUCCESS, data });
export const onModifierLoadFail = (e) => ({ type: MODIFIER_LOAD_FAIL, e });

export const onModifierNewLoad = () => ({type: MODIFIER_NEW_LOAD});
export const onModifierNewLoadSuccess = () => ({ type: MODIFIER_NEW_LOAD_SUCCESS });
export const onModifierNewLoadFail = (e) => ({ type: MODIFIER_NEW_LOAD_FAIL, e });

export const onModifierNew = (id, data) => ({type: MODIFIER_NEW, id, data});
export const onModifierNewSuccess = (response) => ({ type: MODIFIER_NEW_SUCCESS, response });
export const onModifierNewFail = (e) => ({ type: MODIFIER_NEW_FAIL, e });

export const onModifierRemove = (cat_id, id) => ({type: MODIFIER_REMOVE, cat_id, id});
export const onModifierRemoveSuccess = (response) => ({ type: MODIFIER_REMOVE_SUCCESS, response });
export const onModifierRemoveFail = (e) => ({ type: MODIFIER_REMOVE_FAIL, e });

export const onModifiersChangeStatus = (status) => ({type: MODIFIERS_CHANGE_STATUS, status })

export const onModifiersChangePosition = (items) => ({type: MODIFIERS_CHANGE_POSITION, items })
export const onModifiersChangePositionSuccess = () => ({type: MODIFIERS_CHANGE_POSITION_SUCCESS })
export const onModifiersChangePositionFail = () => ({type: MODIFIERS_CHANGE_POSITION_FAIL })

export const onModifiersChangeItemPosition = (items) => ({type: MODIFIERS_CHANGE_ITEM_POSITION, items })
export const onModifiersChangeItemPositionSuccess = () => ({type: MODIFIERS_CHANGE_ITEM_POSITION_SUCCESS })
export const onModifiersChangeItemPositionFail = () => ({type: MODIFIERS_CHANGE_ITEM_POSITION_FAIL })

export const onModifiersNew = (data, slug) => ({type: MODIFIERS_NEW, data, slug })
export const onModifiersNewSuccess = (response) => ({type: MODIFIERS_NEW_SUCCESS, response })
export const onModifiersNewFail = (e) => ({type: MODIFIERS_NEW_FAIL, e })

export const onModifiersEdit = (data, slug) => ({type: MODIFIERS_EDIT, data, slug })
export const onModifiersEditSuccess = (response) => ({type: MODIFIERS_EDIT_SUCCESS, response })
export const onModifiersEditFail = (e) => ({type: MODIFIERS_EDIT_FAIL, e })

export const onModifierCategoryNameEdit = (data) => ({type: MODIFIER_CATEGORY_NAME_EDIT, data })
export const onModifierCategoryNameEditSuccess = (response) => ({type: MODIFIER_CATEGORY_NAME_EDIT_SUCCESS, response })
export const onModifierCategoryNameEditFail = (e) => ({type: MODIFIER_CATEGORY_NAME_EDIT_FAIL, e })

export const onModifierEdit = (id, data) => ({type: MODIFIER_EDIT, id, data })
export const onModifierEditSuccess = (response) => ({type: MODIFIER_EDIT_SUCCESS, response })
export const onModifierEditFail = (e) => ({type: MODIFIER_EDIT_FAIL, e })

export const onModifiersModalNew = (show) => ({type: MODIFIERS_MODAL_NEW, show })
export const onModifiersModalEdit = (show) => ({type: MODIFIERS_MODAL_EDIT, show })

export const onModifierCategoriesNew = (name) => ({type: MODIFIER_CATEGORIES_NEW, name })
export const onModifierCategoriesNewSuccess = (response) => ({type: MODIFIER_CATEGORIES_NEW_SUCCESS, response })
export const onModifierCategoriesNewFail = (e) => ({type: MODIFIER_CATEGORIES_NEW_FAIL, e })

export const onModifierArchive = (id) => ({ type: MODIFIER_ARCHIVE, id });
export const onModifierArchiveSuccess = (data) => ({ type: MODIFIER_ARCHIVE_SUCCESS, data });
export const onModifierArchiveFail = (e) => ({ type: MODIFIER_ARCHIVE_FAIL, e });

export const onModifierUnarchive = (id) => ({ type: MODIFIER_UNARCHIVE, id });
export const onModifierUnarchiveSuccess = (data) => ({ type: MODIFIER_UNARCHIVE_SUCCESS, data });
export const onModifierUnarchiveFail = (e) => ({ type: MODIFIER_UNARCHIVE_FAIL, e });

